// import React, { forwardRef } from "react";
// import Printable from "../A4";

// const TicketPrint = forwardRef(({ ticket }, ref) => {
//   if (!ticket) return null;

//   const date = new Date(ticket.ticketDate).toLocaleDateString("en-GB");

//   const itemStyle = {
//     display: "flex",
//     alignItems: "center",
//   };

//   const labelStyle = {
//     width: "110px", // fixed width for all labels
//     fontWeight: "bold",
//   };
//   return (
//     <Printable ref={ref} documentTitle="Patient Ticket">
//       <div style={{ width: "100%", padding: "20px", fontSize: "14px" }}>
//         {/* Clinic Header */}
//         <div style={{ textAlign: "center", marginBottom: "10px" }}>
//           <h2 style={{ margin: 0, color: "green" }}>ABC Medical Clinic</h2>
//           <h4 style={{ margin: "4px 0", fontSize: "18px" }}>
//             Appointment Ticket
//           </h4>
//         </div>

//         <hr />

//         {/* Grid 4x2 */}
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "1fr 1fr",
//             gap: "12px",
//             marginTop: "15px",
//           }}
//         >
//           <div style={itemStyle}>
//             <span style={labelStyle}>Ticket No:</span>
//             <span>{ticket.ticketNumber}</span>
//           </div>

//           <div style={itemStyle}>
//             <span style={labelStyle}>Date:</span>
//             <span>{date}</span>
//           </div>

//           <div style={itemStyle}>
//             <span style={labelStyle}>Patient:</span>
//             <span>{ticket.patientName}</span>
//           </div>

//           <div style={itemStyle}>
//             <span style={labelStyle}>Doctor:</span>
//             <span>{ticket.physicianName}</span>
//           </div>

//           <div style={itemStyle}>
//             <span style={labelStyle}>Service:</span>
//             <span>{ticket.service}</span>
//           </div>

//           <div style={itemStyle}>
//             <span style={labelStyle}>Status:</span>
//             <span>{ticket.status}</span>
//           </div>

//           <div style={itemStyle}>
//             <span style={labelStyle}>Amount:</span>
//             <span>{ticket.amount}</span>
//           </div>

//           <div style={itemStyle}>
//             <span style={labelStyle}>Paid:</span>
//             <span style={{ fontWeight: "bold" }}>{ticket.amountPaid ?? 0}</span>
//           </div>
//         </div>

//         {/* Note */}
//         <div style={{ marginTop: "12px" }}>
//           <span style={labelStyle}>Note:</span> Please keep this ticket for
//           consultation. Please keep this ticket for consultation.
//         </div>
//       </div>
//     </Printable>
//   );
// });

// TicketPrint.displayName = "TicketPrint";

// export default TicketPrint;

// import React, { forwardRef } from "react";
// import Barcode from "react-barcode";
// import Printable from "../A4";
// import Logo from "../../../assets/img/clinic-logo.png"

// const TicketPrint = forwardRef(({ ticket }, ref) => {
//   if (!ticket) return null;

//   const date = new Date(ticket.ticketDate).toLocaleDateString("en-GB");

//   const totalAmount =
//     ticket?.services?.reduce(
//       (sum, item) => sum + (Number(item.serviceFee) || 0),
//       0,
//     ) || 0;

//   const paidAmount = Number(ticket.amountPaid || 0);

//   const balance = totalAmount - paidAmount;

//   return (
//     <Printable ref={ref} documentTitle="Patient Ticket">
//       <div
//         style={{
//           width: "100%",
//           padding: "20px 25px",
//           fontFamily: "Arial",
//           color: "#000",
//           fontSize: "13px",
//         }}
//       >
//         {/* HEADER */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "flex-start",
//             paddingBottom: "10px",
//           }}
//         >
//           {/* LEFT SIDE */}
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               flex: 1,
//             }}
//           >
//             {/* TOP ROW */}
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "flex-start",
//                 gap: "12px",
//               }}
//             >
//               {/* LOGO */}
//               <div
//                 style={{
//                   width: "62px",
//                   height: "62px",
//                   flexShrink: 0,
//                   overflow: "hidden",
//                   border: "1px solid #ccc",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   background: "#fff",
//                 }}
//               >
//                 <img
//                   src={Logo}
//                   alt="Clinic Logo"
//                   style={{
//                     width: "100%",
//                     height: "100%",
//                     objectFit: "fil",
//                   }}
//                 />
//               </div>

//               {/* CLINIC TITLE */}
//               <div style={{ paddingTop: "4px" }}>
//                 <h2
//                   style={{
//                     margin: 0,
//                     fontSize: "22px",
//                     fontWeight: "700",
//                   }}
//                 >
//                   ABC Medical Clinic
//                 </h2>

//                 <div
//                   style={{
//                     marginTop: "4px",
//                     fontSize: "13px",
//                   }}
//                 >
//                   Diagnostic & Laboratory Centre
//                 </div>
//               </div>
//             </div>

//             {/* TICKET NUMBER */}
//             <div
//               style={{
//                 marginTop: "10px",
//                 border: "1px solid #000",
//                 width: "160px",
//                 textAlign: "center",
//                 fontSize: "18px",
//                 fontWeight: "700",
//                 letterSpacing: "2px",
//               }}
//             >
//               {ticket.ticketNumber}
//             </div>
//           </div>

//           {/* RIGHT SIDE */}
//           <div
//             style={{
//               textAlign: "right",
//               maxWidth: "320px",
//             }}
//           >
//             {/* ADDRESS */}
//             <div
//               style={{
//                 fontSize: "14px",
//                 lineHeight: "21px",
//               }}
//             >
//               31-E, Johar Town Lahore
//               <br />
//               Near Expo Center Lahore
//               <br />
//               Helpline: 0300-0000000
//             </div>

//             {/* PATIENT COPY */}
//             <div
//               style={{
//                 border: "1px solid #000",
//                 padding: "6px 18px",
//                 fontWeight: "700",
//                 marginTop: "4px",
//                 marginBottom: "1px",
//                 display: "inline-block",
//                 minWidth: "180px",
//                 textAlign: "center",
//               }}
//             >
//               Patient Copy
//             </div>

//             {/* BARCODE */}
//             <div style={{ marginRight: "-9px" }}>
//               <Barcode
//                 value={String(ticket.ticketNumber)}
//                 // width={1.3}
//                 height={40}
//                 fontSize={14}
//                 displayValue={true}
//               />
//             </div>
//           </div>
//         </div>

//         {/* PATIENT INFO */}
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "1fr 1fr",
//             gap: "10px",
//             // marginTop: "15px",
//             marginBottom: "10px",
//           }}
//         >
//           {/* LEFT */}
//           <div>
//             <div style={{ marginBottom: "7px" }}>
//               <strong>Name:</strong> {ticket.patientName}
//             </div>

//             <div style={{ marginBottom: "7px" }}>
//               <strong>Doctor:</strong> {ticket.physicianName}
//             </div>

//             <div style={{ marginBottom: "7px" }}>
//               <strong>Ticket No:</strong> {ticket.ticketNumber}
//             </div>
//           </div>

//           {/* RIGHT */}
//           <div>
//             <div style={{ marginBottom: "7px" }}>
//               <strong>Date:</strong> {date}
//             </div>

//             <div style={{ marginBottom: "7px" }}>
//               <strong>Status:</strong> {ticket.status}
//             </div>

//             <div style={{ marginBottom: "7px" }}>
//               <strong>Paid:</strong> {paidAmount}
//             </div>
//           </div>
//         </div>

//         {/* SERVICES TABLE */}
//         <table
//           style={{
//             width: "100%",
//             borderCollapse: "collapse",
//             marginTop: "10px",
//             fontSize: "13px",
//           }}
//         >
//           <thead>
//             <tr
//               style={{
//                 borderTop: "1px solid #000",
//                 borderBottom: "1px solid #000",
//               }}
//             >
//               <th
//                 style={{
//                   textAlign: "left",
//                   padding: "8px",
//                 }}
//               >
//                 Service
//               </th>

//               {/* <th
//                 style={{
//                   textAlign: "center",
//                   padding: "8px",
//                   width: "150px",
//                 }}
//               >
//                 Status
//               </th> */}

//               <th
//                 style={{
//                   textAlign: "right",
//                   padding: "8px",
//                   width: "120px",
//                 }}
//               >
//                 Amount
//               </th>
//             </tr>
//           </thead>

//           <tbody>
//             {ticket?.services?.map((item, index) => (
//               <tr
//                 key={index}
//                 style={{
//                   borderBottom: "1px solid #ddd",
//                 }}
//               >
//                 <td style={{ padding: "8px" }}>{item.serviceName}</td>

//                 {/* <td
//                   style={{
//                     textAlign: "center",
//                     padding: "8px",
//                   }}
//                 >
//                   {item.status}
//                 </td> */}

//                 <td
//                   style={{
//                     textAlign: "right",
//                     padding: "8px",
//                   }}
//                 >
//                   {item.serviceFee}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {/* TOTAL SECTION */}
//         <div
//           style={{
//             width: "300px",
//             marginLeft: "auto",
//             marginTop: "20px",
//             fontSize: "14px",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               marginBottom: "8px",
//             }}
//           >
//             <strong>Total:</strong>
//             <span>{totalAmount}</span>
//           </div>

//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               marginBottom: "8px",
//             }}
//           >
//             <strong>Received:</strong>
//             <span>{paidAmount}</span>
//           </div>

//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               borderTop: "1px solid #000",
//               paddingTop: "8px",
//               fontWeight: "700",
//             }}
//           >
//             <strong>Balance:</strong>
//             <span>{balance}</span>
//           </div>
//         </div>

//         {/* FOOTER */}
//         <div
//           style={{
//             marginTop: "20px",
//             border: "1px solid #000",
//             marginTop: "170px",
//             padding: "6px",
//             fontSize: "12px",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "flex-start",
//               gap: "30px",
//             }}
//           >
//             {/* LEFT CONTENT */}
//             <div
//               style={{
//                 flex: 1,
//                 lineHeight: "18px",
//               }}
//             >
//               {/* LINE 1 */}
//               <div>
//                 <span style={{ fontWeight: "bold" }}>Online Patient Care:</span>{" "}
//                 You can view your reports online at{" "}
//                 <span style={{ fontWeight: "bold" }}>
//                   https://abcclinic.com/reports
//                 </span>
//               </div>
//               {/* LINE 2 */}
//               <div style={{ marginTop: "3px" }}>
//                 using MR No:{" "}
//                 <span style={{ fontWeight: "bold" }}>
//                   {ticket.patientMrNo || "N/A"}
//                 </span>{" "}
//                 & Password: <span style={{ fontWeight: "bold" }}>123456</span>{" "}
//                 or scan following QR Code thorugh your Mobile
//               </div>
//             </div>

//             {/* QR CODE */}
//             <div
//               style={{
//                 width: "55px",
//                 height: "55px",
//                 border: "1px solid #000",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontSize: "10px",
//                 flexShrink: 0,
//               }}
//             >
//               QR
//             </div>
//           </div>
//         </div>
//         {/* BOTTOM */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             // paddingTop: "5px",
//             fontSize: "11px",
//           }}
//         >
//           <div>Powered By ABC Software Solutions</div>

//           <div>Page 1 of 1</div>
//         </div>
//       </div>
//     </Printable>
//   );
// });

// TicketPrint.displayName = "TicketPrint";

// export default TicketPrint;

import React, { forwardRef } from "react";
import Barcode from "react-barcode";
import QRCode from "react-qr-code";

import Printable from "../A4";
import Logo from "../../../assets/img/clinic-logo.png";

const TicketPrint = forwardRef(({ ticket }, ref) => {
  if (!ticket) return null;

  // const date = new Date(ticket.ticketDate).toLocaleDateString("en-GB");

  const d = new Date(ticket.ticketDate);

  const date = `${d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
  })}, ${d.getFullYear()}`;

  const totalAmount =
    ticket?.services?.reduce(
      (sum, item) => sum + (Number(item.serviceFee) || 0),
      0,
    ) || 0;

  const paidAmount = Number(ticket.amountPaid || 0);

  const balance = totalAmount - paidAmount;

  // DYNAMIC QR LINK
  const baseUrl = typeof window !== "undefined" ? window.location.origin : "";

  const qrLink = `${baseUrl}/find-ticket?id=${ticket.ticketNumber}`;
  // const qrLink = `https://abcclinic.com/find-ticket?id=${ticket.ticketNumber}`;

  return (
    <Printable ref={ref} documentTitle="Patient Ticket">
      <div
        style={{
          width: "100%",
          padding: "18px 24px",
          fontFamily: "Arial, sans-serif",
          color: "#000",
          fontSize: "13px",
          background: "#fff",
        }}
      >
        {/* ================= HEADER ================= */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          {/* LEFT SIDE */}
          <div style={{ flex: 1 }}>
            <div
              style={{
                display: "flex",
                gap: "12px",
                alignItems: "flex-start",
              }}
            >
              {/* LOGO */}
              <div
                style={{
                  width: "58px",
                  height: "58px",
                  border: "1px solid #d9d9d9",
                  overflow: "hidden",
                  background: "#fff",
                  flexShrink: 0,
                }}
              >
                <img
                  src={Logo}
                  alt="logo"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>

              {/* CLINIC INFO */}
              <div>
                <div
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    marginBottom: "2px",
                  }}
                >
                  ABC Medical Clinic
                </div>

                <div
                  style={{
                    fontSize: "12px",
                    color: "#444",
                  }}
                >
                  Diagnostic & Laboratory Centre
                </div>
              </div>
            </div>

            {/* PATIENT COPY */}
            <div
              style={{
                border: "1px solid #000",
                width: "165px",
                textAlign: "center",
                padding: "5px 0",
                marginTop: "12px",
                fontWeight: "600",
                fontSize: "13px",
              }}
            >
              Patient Copy
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div
            style={{
              width: "270px",
              textAlign: "right",
            }}
          >
            {/* ADDRESS + QR */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: "10px",
              }}
            >
              {/* ADDRESS */}
              <div
                style={{
                  fontSize: "12px",
                  lineHeight: "19px",
                  textAlign: "right",
                  flex: 1,
                }}
              >
                31-E, Johar Town Lahore
                <br />
                Near Expo Center Lahore
                <br />
                Helpline: 0300-0000000
              </div>

              {/* QR CODE */}
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  padding: "3px",
                  marginTop: "3px",
                  border: "1px solid #000",
                  background: "#fff",
                  flexShrink: 0,
                }}
              >
                <QRCode
                  value={qrLink}
                  size={48}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </div>

            {/* BARCODE */}
            <div
              style={{
                marginTop: "8px",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <div>
                <Barcode
                  value={String(ticket.ticketNumber)}
                  // width={1.2}
                  height={35}
                  fontSize={13}
                  margin={0}
                  displayValue={false}
                />

                <div
                  style={{
                    textAlign: "center",
                    marginTop: "3px",
                    fontSize: "13px",
                  }}
                >
                  {ticket.ticketNumber}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ================= INFO ROW ================= */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "22px",
            marginBottom: "16px",
            fontSize: "13px",
          }}
        >
          <div>
            <strong>Name:</strong> {ticket.patientName}
          </div>

          <div>
            <strong>Doctor:</strong> {ticket.physicianName}
          </div>

          <div>
            <strong>Date:</strong> {date}
          </div>
        </div>

        {/* ================= TABLE ================= */}
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "13px",
          }}
        >
          <thead>
            <tr
              style={{
                borderTop: "1px solid #000",
                borderBottom: "1px solid #000",
              }}
            >
              <th
                style={{
                  textAlign: "left",
                  padding: "8px 6px",
                }}
              >
                Services
              </th>

              <th
                style={{
                  textAlign: "right",
                  padding: "8px 6px",
                  width: "120px",
                }}
              >
                Amount
              </th>
            </tr>
          </thead>

          <tbody>
            {ticket?.services?.map((item, index) => (
              <tr
                key={index}
                style={{
                  borderBottom: "1px solid #e5e5e5",
                }}
              >
                <td
                  style={{
                    padding: "9px 6px",
                  }}
                >
                  {item.serviceName}
                </td>

                <td
                  style={{
                    padding: "9px 6px",
                    textAlign: "right",
                  }}
                >
                  {item.serviceFee}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* ================= TOTALS ================= */}
        <div
          style={{
            width: "280px",
            marginLeft: "auto",
            marginTop: "18px",
            fontSize: "14px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "10px",
            }}
          >
            <strong>Total:</strong>
            <span>{totalAmount}</span>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "10px",
            }}
          >
            <strong>Received:</strong>
            <span>{paidAmount}</span>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              borderTop: "1px solid #000",
              paddingTop: "10px",
              fontWeight: "700",
            }}
          >
            <strong>Balance:</strong>
            <span>{balance}</span>
          </div>
        </div>
      </div>
    </Printable>
  );
});

TicketPrint.displayName = "TicketPrint";

export default TicketPrint;
